var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCloseRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.8203L15.5 8.82031M15.5 15.8203L8.5 8.82031M14.9 2.32031H9.1C8.42 2.32031 7.46 2.72031 6.98 3.20031L2.88 7.30031C2.4 7.78031 2 8.74031 2 9.42031V15.2203C2 15.9003 2.4 16.8603 2.88 17.3403L6.98 21.4403C7.46 21.9203 8.42 22.3203 9.1 22.3203H14.9C15.58 22.3203 16.54 21.9203 17.02 21.4403L21.12 17.3403C21.6 16.8603 22 15.9003 22 15.2203V9.42031C22 8.74031 21.6 7.78031 21.12 7.30031L17.02 3.20031C16.54 2.72031 15.58 2.32031 14.9 2.32031Z",
    stroke: "#EE5D50",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseRed);
export default __webpack_public_path__ + "static/media/ic_close_red.4ed62f2d0978bab11a1440db0dd9f0cf.svg";
export { ForwardRef as ReactComponent };